var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useContext, useMemo, useState } from 'react';
var LocalDataContext = createContext({
    finderColumnsInvalidator: 0,
    filterTagIds: [],
    withDataMap: new Map(),
    addFilterTagIds: function (id) { },
    removeFilterTagIds: function (id) { },
    forceFinderColumnInvalidation: function () { },
    setWithData: function (parentId, id, withData) { },
});
function LocalDataProvider(_a) {
    var children = _a.children;
    var _b = __read(useState(0), 2), finderColumnsInvalidator = _b[0], setFinderColumnsInvalidator = _b[1];
    var _c = __read(useState([]), 2), filterTagIds = _c[0], setFilterTagIds = _c[1];
    var _d = __read(useState(new Map()), 2), withDataMap = _d[0], setWithDataMap = _d[1];
    var ctx = useMemo(function () { return ({
        withDataMap: withDataMap,
        filterTagIds: filterTagIds,
        finderColumnsInvalidator: finderColumnsInvalidator,
        setWithData: function (parentId, childId, withData) {
            setWithDataMap(function (current) {
                var _a;
                var updated = new Map(current);
                var children = (_a = current.get(parentId)) !== null && _a !== void 0 ? _a : [];
                if (children.length > 0) {
                    var targetIdx = children.findIndex(function (c) { return c.childId === childId; });
                    if (targetIdx !== -1) {
                        children[targetIdx] = __assign(__assign({}, children[targetIdx]), { withData: withData });
                    }
                    else {
                        children.push({ childId: childId, withData: withData });
                    }
                    updated.set(parentId, children);
                    return updated;
                }
                updated.set(parentId, [{ childId: childId, withData: withData }]);
                return updated;
            });
        },
        addFilterTagIds: function (id) {
            var copy = __spreadArray(__spreadArray([], __read(filterTagIds), false), [id], false);
            setFilterTagIds(copy);
        },
        removeFilterTagIds: function (id) {
            setFilterTagIds(filterTagIds.filter(function (fId) { return fId !== id; }));
        },
        forceFinderColumnInvalidation: function () { return setFinderColumnsInvalidator(Math.floor(Math.random() * 1000000)); },
    }); }, [withDataMap, filterTagIds, finderColumnsInvalidator]);
    return React.createElement(LocalDataContext.Provider, { value: ctx }, children);
}
export default LocalDataProvider;
export function useLocalData() {
    return useContext(LocalDataContext);
}
